import React, {Fragment} from 'react';
import Tabs from 'react-responsive-tabs';
import { useForm } from "react-hook-form";
import LegacyEmailParser from "../LegacySettings/LegacyEmailParser";
import LegacyInbound from "../LegacySettings/LegacyInbound";
import { getAppType } from '../../../Common/Appcommon';

const EmailParser = props => {

    function GetTabsContent () {
        const form = useForm();
        const appType = getAppType();
        const tabsContent = [
            {
                title: 'Email To Leads',
                content: <LegacyEmailParser onBackAction={props.onBackAction} />,
                groupname : 'legacy',
            },
            {
                title: 'Inbound Mails',
                content: <LegacyInbound onBackAction={props.onBackAction} />,
                groupname : "legacy",
            }
        ];
        let modifiedTabs = tabsContent;
        if(appType === '0') {
            modifiedTabs = [];
            tabsContent.map((tab, index) => {
                if(tab.groupname !== "legacy"){
                    modifiedTabs.push(tab);
                }
            })
        }
        return modifiedTabs;
    }
    function getTabs() {
        let tabsContent = GetTabsContent();
        return tabsContent.map((tab, index) => ({
            title: tab.title,
            getContent: () => tab.content,
            key: index,
        }));
    }

    return (
        <Fragment>
            <Tabs
                tabsWrapperClass="body-tabs body-tabs-layout header-tab-padding"
                transform={false}
                showInkBar={true}
                items={getTabs()}
            />
        </Fragment>
    )


}

export default EmailParser;